import { memo } from "react";

import { cn } from "@/lib/chillnn/cn";
import { sanitize } from "@/lib/dompurify";
import type { QuestionType } from "@/lib/gql/__generated__/graphql";

import { FeatureIslandCategoryQuestionForMain } from "@/components/features/_layouts/island/main-with-category/components/category-main-question";
import type { ForNodeType } from "@/components/features/_model/types";

import { CheckboxField } from "@/components/ui/form/fields/check-box-field/check-box";

type QuestionsType = {
	questionID: string;
	required?: boolean | null | undefined;
	questionType: QuestionType;
	question: string;
	options?: string[] | null | undefined;
}[];

type Props = {
	questions: QuestionsType;
	isHiddenHotelQuestions: ForNodeType<boolean>;

	onSetIsHiddenHotelQuestions: (input: boolean) => void;
};

// ホテルポリシーで設定した事前質問の設定
const QuestionPlanDefaultQuestions = memo(
	({ questions, isHiddenHotelQuestions }: { questions: QuestionsType; isHiddenHotelQuestions: boolean }) => {
		return questions.length > 0 ? (
			<div className={cn("space-y-4", isHiddenHotelQuestions ? "text-zinc-400" : "")}>
				<h3 className="text-base font-semibold">ホテルポリシーで設定した事前質問</h3>

				{questions.map((item, idx) => {
					const key = item.questionID;

					return (
						<div key={key} className="ml-1 text-sm">
							<p className="mb-1 font-semibold">事前質問 {idx + 1}</p>
							<div className="ml-4">
								<div className="mb-2">
									{/* <a>タグが存在していたら、テキストカラーを水色にする */}
									<h4
										className="whitespace-pre-wrap [&>a]:text-link-400 [&>a]:underline-offset-2 [&>a]:hover:underline"
										dangerouslySetInnerHTML={{ __html: sanitize(item.question) }}
									/>
								</div>
							</div>
						</div>
					);
				})}
			</div>
		) : (
			<div className="ml-4">
				<p>※ ホテルポリシーで設定した事前質問はありません</p>
			</div>
		);
	},
);

export const QuestionPlanIsHiddenHotelQuestions = memo(
	({ questions, isHiddenHotelQuestions, onSetIsHiddenHotelQuestions }: Props) => {
		const guide =
			"「ホテルポリシー編集画面」で設定した事前質問は、プランに関わらず全てのゲストに対して表示されます。";

		return (
			<div className="space-y-10">
				<FeatureIslandCategoryQuestionForMain
					required={false}
					title={"ホテル全体の質問を非表示"}
					isEdited={isHiddenHotelQuestions.isEdited}
					hasError={Boolean(isHiddenHotelQuestions.error)}
					guide={guide}
					inputChildren={
						<CheckboxField
							value={isHiddenHotelQuestions.value}
							label={"「ホテルポリシーの設定ページ」で設定した事前質問を非表示にする"}
							handleChange={onSetIsHiddenHotelQuestions}
							errorMessage={isHiddenHotelQuestions.error}
						/>
					}
				/>

				<QuestionPlanDefaultQuestions
					questions={questions}
					isHiddenHotelQuestions={isHiddenHotelQuestions.value}
				/>
			</div>
		);
	},
);

QuestionPlanIsHiddenHotelQuestions.displayName = "QuestionPlanIsHiddenHotelQuestions";
